import React from 'react';
import { Route, Routes } from 'react-router-dom';

const Doctor = React.lazy(() =>
  import('../components/pages/doctors/Doctors.jsx')
);
const SendMessages = React.lazy(() =>
  import('../components/pages/send-messages/SendMessages.jsx')
);

function PublicRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Doctor />} />
      <Route path="/send-messages" element={<SendMessages />} />
    </Routes>
  );
}

export { PublicRoutes };
